import { render, staticRenderFns } from "./ClassesCustomersGenerateLink.vue?vue&type=template&id=45fb38be"
import script from "./ClassesCustomersGenerateLink.vue?vue&type=script&lang=js"
export * from "./ClassesCustomersGenerateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports